import { ERROR, SUCCESS } from "../constants/types/alertType";
import {
  ADDITIONAL_HERB_ADDED_TO_FORMULA,
  ALL_HERB_LIST_RECEIVED,
  CLASSIC_FORMULA_LIST_RECEIVED,
  CUSTOM_FORMULA_LIST_RECEIVED,
  DISEASES_RECEIVED,
  FAVORITE_FORMULA_LIST_RECEIVED,
  FORMULA_BY_ID_RECEIVED,
  FORMULA_HERB_ITEM_EDITED,
  FORMULA_LOCKED,
  FORMULA_REMOVED_FROM_SECTION,
  FORMULA_TOTAL_CHANGED,
  FORMULA_TYPE_CHANGED,
  FORMULA_TYPE_CHANGED_FROM_RAW_TO_GRANULAR,
  FORMULA_TYPE_CHANGED_FROM_GRANULAR_TO_RAW,
  HERBS_BY_FORMULA_ID_RECEIVED,
  HERBS_BY_ID_RECEIVED,
  HERB_REMOVED_FROM_FORMULA,
  MODIFICATION_BY_FORMULA_ID_RECEIVED,
  MODIFICATION_BY_ID_RECEIVED,
  RENDER_FORMULA_LIST,
  SET_ACTIVE_CUSTOM_FORMULA,
  SINGLE_HERB_ADDED_TO_LIST,
  SINGLE_HERB_FROM_PRESCRIPTION_ADDED_TO_LIST,
  SINGLE_HERB_ITEM_EDITED,
  SINGLE_HERB_LIST_LOCKED,
  SINGLE_HERB_REMOVED_FROM_LIST,
  SINGLE_HERB_TOTAL_CHANGED,
  SUBCLASS_BY_ID_RECEIVED,
  ACUMATICA_FORMULA_BY_FORMULA_ID_RECEIVED,
  RESTORE_RAW_HERBS,
} from "../constants/types/formulaType";
import axios from "../utils/axios";

export const setActiveCustomFormula = (formula) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_CUSTOM_FORMULA,
    payload: formula,
  });
};
export const getCustomFormula = (callback) => (dispatch) => {
  axios.get("customFormulas").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: CUSTOM_FORMULA_LIST_RECEIVED,
          payload: resp.data.formulaList,
        });
      } else {
        dispatch({
          type: CUSTOM_FORMULA_LIST_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const getFavoriteFormula = (callback) => (dispatch) => {
  axios.get("favoriteFormulas").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: FAVORITE_FORMULA_LIST_RECEIVED,
          payload: resp.data.formulaList,
        });
      } else {
        dispatch({
          type: FAVORITE_FORMULA_LIST_RECEIVED,
          payload: [],
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const addFormulaNote = (id, note, callback) => (dispatch) => {
  axios.get(`notes?formula_id=${id}&notes=${note}`).then(
    (resp) => {
      if (resp.data.message) {
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
        callback && callback();
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const favoriteFormulaPostAction = (data, callback) => (dispatch) => {
  axios.post("favoriteFormulas", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const customFormulaPostAction = (data, callback) => (dispatch) => {
  axios.post("customFormulas", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getClassicFormula = () => (dispatch) => {
  axios.get("formulas").then(
    (resp) => {
      if (resp.data) {
        dispatch({
          type: CLASSIC_FORMULA_LIST_RECEIVED,
          payload: resp.data,
        });
      } else {
        dispatch({
          type: CLASSIC_FORMULA_LIST_RECEIVED,
          payload: [],
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getAllHerbs = (callback) => (dispatch) => {
  axios.get("herbs").then(
    (resp) => {
      if (resp.data) {
        dispatch({
          type: ALL_HERB_LIST_RECEIVED,
          payload: resp.data,
        });
        callback && callback();
      } else {
        dispatch({
          type: ALL_HERB_LIST_RECEIVED,
          payload: [],
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getDiseaseClassification = () => (dispatch) => {
  axios.get("diseases").then(
    (resp) => {
      dispatch({
        type: DISEASES_RECEIVED,
        payload: resp.data ? resp.data : [],
      });
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getSubclassById = (disease_id, callback) => (dispatch) => {
  axios.get(`subclasses?disease_id=${disease_id}`).then(
    (resp) => {
      dispatch({
        type: SUBCLASS_BY_ID_RECEIVED,
        payload: resp.data ? resp.data : [],
      });
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const getFormulaById =
  (disease_id, subclass_id, callback) => (dispatch) => {
    axios
      .get(`formulas?disease_id=${disease_id}&subclass_id=${subclass_id}`)
      .then(
        (resp) => {
          dispatch({
            type: FORMULA_BY_ID_RECEIVED,
            payload: resp.data ? resp.data : [],
          });
          callback && callback();
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
          callback && callback();
        }
      );
  };

export const getModificationById =
  (disease_id, subclass_id, formula_id, callback) => (dispatch) => {
    axios
      .get(
        `mods?disease_id=${disease_id}&subclass_id=${subclass_id}&formula_id=${formula_id}`
      )
      .then(
        (resp) => {
          dispatch({
            type: MODIFICATION_BY_ID_RECEIVED,
            payload: resp.data ? resp.data : [],
          });
          callback && callback();
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
          callback && callback();
        }
      );
  };
export const getModificationByFormulaId =
  (formula_id, callback) => (dispatch) => {
    axios.get(`mods?formula_id=${formula_id}`).then(
      (resp) => {
        dispatch({
          type: MODIFICATION_BY_FORMULA_ID_RECEIVED,
          payload: resp.data ? resp.data : [],
        });
        callback && callback();
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
        callback && callback();
      }
    );
  };

export const getHerbById =
  (disease_id, subclass_id, formula_id, mod_id, mod_name, includeDosage) =>
  (dispatch) => {
    axios
      .get(
        `herbs?disease_id=${disease_id}&subclass_id=${subclass_id}&formula_id=${formula_id}&mod_id=${mod_id}`
      )
      .then(
        (resp) => {
          if (resp.data.length > 0) {
            dispatch({
              type: HERBS_BY_ID_RECEIVED,
              payload: resp.data
                ? {
                    formula_id: formula_id,
                    herbs: resp.data.map((x) => {
                      x.MOD_Dosage = includeDosage ? x.MOD_Dosage : 0;
                      return x;
                    }),
                    mod_name: mod_name,
                    mod_id: mod_id,
                  }
                : [],
            });
          } else {
            dispatch({
              type: ERROR,
              payload:
                "This modification is being updated and is not available currently",
            });
          }
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
        }
      );
  };

export const getHerbByFormulaId =
  (formula_id, formula_name, callback, dosage = 0) =>
  (dispatch) => {
    axios.get(`herbs?formula_id=${formula_id}`).then(
      (resp) => {
        dispatch({
          type: HERBS_BY_FORMULA_ID_RECEIVED,
          payload: resp.data
            ? {
                data: resp.data,
                formula_id: formula_id,
                formula_name: formula_name,
                dosage: dosage,
              }
            : [],
        });
        callback && callback();
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
      }
    );
  };

export const getAcumaticaHerbById =
  (formula_id, callback, dosage = 0) =>
  (dispatch) => {
    axios
      .get(
        `prescriptionsPractitioner?action=getAcumaticaFormulaById&formula_id=${formula_id}`
      )
      .then(
        (resp) => {
          dispatch({
            type: ACUMATICA_FORMULA_BY_FORMULA_ID_RECEIVED,
            payload: resp.data
              ? {
                  data: resp.data,
                  dosage,
                }
              : [],
          });
          callback && callback();
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
        }
      );
  };
export const getCustomHerbByFormulaId =
  (formula_id, formula_name, callback, dosage = 0, isCustom = false) =>
  (dispatch) => {
    axios.get(`herbs?custom_id=${formula_id}`).then(
      (resp) => {
        dispatch({
          type: HERBS_BY_FORMULA_ID_RECEIVED,
          payload: resp.data
            ? {
                data: resp.data,
                formula_id: formula_id,
                formula_name: formula_name,
                dosage: dosage,
                isCustom: isCustom,
              }
            : [],
        });
        callback && callback();
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
      }
    );
  };

export const addItemToSingleHerbList = (item) => (dispatch) => {
  dispatch({
    type: SINGLE_HERB_ADDED_TO_LIST,
    payload: item,
  });
};

export const addPresciptionItemToSingleHerbList = (item) => (dispatch) => {
  dispatch({
    type: SINGLE_HERB_FROM_PRESCRIPTION_ADDED_TO_LIST,
    payload: item,
  });
};

export const addAdditionalHerbToFormula = (formulaId, item) => (dispatch) => {
  dispatch({
    type: ADDITIONAL_HERB_ADDED_TO_FORMULA,
    payload: { formulaId: formulaId, herb: item },
  });
};

export const removeFormulaFromSection = (formulaId) => (dispatch) => {
  dispatch({
    type: FORMULA_REMOVED_FROM_SECTION,
    payload: formulaId,
  });
};

export const removeHerbFromFormula = (formulaId, herbId) => (dispatch) => {
  dispatch({
    type: HERB_REMOVED_FROM_FORMULA,
    payload: { formulaId: formulaId, herbId: herbId },
  });
};

export const editFormulaHerbItem =
  (formulaId, herbId, dosage, isLocked, isOuterLocked) => (dispatch) => {
    dispatch({
      type: FORMULA_HERB_ITEM_EDITED,
      payload: {
        formulaId: formulaId,
        herbId: herbId,
        dosage: dosage,
        isLocked: isOuterLocked ? false : isLocked,
        isOuterLocked: isOuterLocked,
      },
    });
  };

export const removeItemFromSingleHerbList = (id) => (dispatch) => {
  dispatch({
    type: SINGLE_HERB_REMOVED_FROM_LIST,
    payload: id,
  });
};

export const editSingleHerbItem =
  (id, dosage, isLocked, isOuterLocked) => (dispatch) => {
    dispatch({
      type: SINGLE_HERB_ITEM_EDITED,
      payload: {
        id: id,
        dosage: dosage,
        isLocked: isOuterLocked ? false : isLocked,
        isOuterLocked: isOuterLocked,
      },
    });
  };

export const changeFormulaType = (isRawType, gram, callback) => (dispatch) => {
  dispatch({
    type: FORMULA_TYPE_CHANGED,
    payload: { isRaw: isRawType, gram: gram },
  });
  callback && callback();
};

export const changeFormulaTypeFromDays =
  (isRawType, days, callback) => (dispatch) => {
    dispatch({
      type: FORMULA_TYPE_CHANGED_FROM_RAW_TO_GRANULAR,
      payload: { isRaw: isRawType, days: days },
    });
    callback && callback();
  };

export const changeFormulaTypeFromGranularToRaw =
  (isRawType, days, callback) => (dispatch) => {
    dispatch({
      type: FORMULA_TYPE_CHANGED_FROM_GRANULAR_TO_RAW,
      payload: { isRaw: isRawType, days: days },
    });
    callback && callback();
  };

export const singleHerbTotalChange = (gram) => (dispatch) => {
  dispatch({
    type: SINGLE_HERB_TOTAL_CHANGED,
    payload: gram,
  });
};

export const formulaTotalChange = (formulaId, gram) => (dispatch) => {
  dispatch({
    type: FORMULA_TOTAL_CHANGED,
    payload: { formulaId: formulaId, gram: gram },
  });
};

export const renderFormulaList = (render) => (dispatch) => {
  dispatch({
    type: RENDER_FORMULA_LIST,
    payload: render,
  });
};

export const lockFormulaByFormulaId = (id, isLocked) => (dispatch) => {
  dispatch({
    type: FORMULA_LOCKED,
    payload: { id: id, isLocked: isLocked },
  });
};

export const lockSingleHerbList = (isLocked) => (dispatch) => {
  dispatch({
    type: SINGLE_HERB_LIST_LOCKED,
    payload: isLocked,
  });
};

export const restoreHerbsForRaw = (herbs, callback) => (dispatch) => {
  dispatch({
    type: RESTORE_RAW_HERBS,
    payload: { herbs: herbs, isRaw: true },
  });
  callback && callback();
};
